import axios from 'axios';
import recordDescriptorProcessing from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

let helpers = {
  getEventHistories(company_id, options){
    const url = `${process.env.REACT_APP_API}/event_histories?current_company=${company_id ? company_id : localStorage.current_company_id}`
      + (options && options.recordDescriptor ? ('&new_serializer=true&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'get',
      url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  getEventHistory(event_history_id, company_id) {
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_API}/event_histories/${event_history_id}?current_company=${company_id ? company_id : localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/eventHistoriesServices.js